import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { navigateToExternalLink } from '@deltek/specification-client/core/Utilities/urlUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline'
import clsx from 'clsx'
import { onEnterKeyDown } from 'pages/ProjectsPage/WorkspacePage/components/Common/utils'
import React from 'react'
import { ImageLink } from './GettingStarted'

const useMediaStyles = makeStyles((theme: Theme) => ({
    videoOverlayContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        border: '1px solid #A78966',
        '&:nth-child(1)': {
            marginBottom: theme.spacing(0.75),
        },
    },
    mediaItem: {
        objectFit: 'fill',
    },
    overlay: {
        background: 'rgba(0,0,0,0.70)',
        position: 'absolute',
    },
    playIcon: {
        position: 'absolute',
        color: '#ffffff',
        zIndex: 1,
    },
    imageHoverLabel: {
        position: 'absolute',
        color: '#ffffff',
        zIndex: 1,
        cursor: 'pointer',
    },
    mainOverlay: {
        width: pxToRem(550),
        height: pxToRem(280),
    },
    subOverlay: {
        width: pxToRem(170),
        height: pxToRem(110),
    },
    majorLabel: {
        marginTop: theme.spacing(8.5),
    },
    minorLabel: {
        marginTop: theme.spacing(6.875),
        fontSize: pxToRem(12),
    },
}))

const ImageHoverOverlay: React.FC<ImageLink> = ({
    isMain,
    src,
    title,
    url,
}) => {
    const classes = useMediaStyles()

    const [isImageLinkHovered, setIsImageLinkHovered] = React.useState<boolean>(
        false
    )

    const handleImageLinkHoverEnter = () => {
        setIsImageLinkHovered(true)
    }

    const handleImageLinkHoverLeave = () => {
        setIsImageLinkHovered(false)
    }

    return (
        <div
            data-testid="imageContainer"
            className={clsx(classes.videoOverlayContainer, 'imageContainer')}
            onMouseEnter={handleImageLinkHoverEnter}
            onMouseLeave={handleImageLinkHoverLeave}
            tabIndex={0}
            onClick={() => navigateToExternalLink(url)}
            onKeyDown={onEnterKeyDown(() => navigateToExternalLink(url))}
        >
            {isImageLinkHovered && (
                <>
                    <PlayCircleOutlineIcon
                        fontSize={isMain ? 'large' : 'default'}
                        className={clsx(classes.playIcon, 'playIconOverlay')}
                    />
                    <label
                        className={clsx(
                            classes.imageHoverLabel,
                            isMain ? classes.majorLabel : classes.minorLabel
                        )}
                    >
                        {title}
                    </label>
                    <div
                        className={clsx(
                            classes.overlay,
                            isMain ? classes.mainOverlay : classes.subOverlay,
                            'imageOverlay'
                        )}
                    />
                </>
            )}

            <img
                alt={title}
                src={src}
                width={isMain ? 550 : 170}
                height={isMain ? 280 : 110}
                className={classes.mediaItem}
            />
        </div>
    )
}

export default ImageHoverOverlay
